import { Observable } from 'rxjs';
import { UrlTree, Router } from '@angular/router';
import { Injectable } from '@angular/core';

import { AccountService } from '../../business-services/account.service'

@Injectable({ providedIn: 'root' })
export class AddAccountDetailsGuard  {
    
    constructor(
        private service: AccountService,
        private router: Router
    ) {}

    canActivateChild(): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
        
        return this.router.createUrlTree(['/account']);
    }

}